// client/src/hooks/useApi.js
// Enkel hook for å hente og oppdatere data fra API-et.
// Brukes i alle komponenter som trenger data fra serveren.

import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

export function useApi(url, deps = []) {
  const [data,    setData]    = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  const fetch = useCallback(async () => {
    if (!url) return;
    setLoading(true);
    try {
      const res = await axios.get(url);
      setData(res.data);
      setError(null);
    } catch (err) {
      setError(err.response?.data?.error || 'Noe gikk galt');
    } finally {
      setLoading(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, ...deps]);

  useEffect(() => { fetch(); }, [fetch]);

  return { data, loading, error, refresh: fetch };
}

// Enkle hjelpefunksjoner for POST, PUT, DELETE
export const api = {
  post:   (url, data)   => axios.post(url, data).then(r => r.data),
  put:    (url, data)   => axios.put(url, data).then(r => r.data),
  delete: (url)         => axios.delete(url).then(r => r.data),
  get:    (url)         => axios.get(url).then(r => r.data),
};
